module.exports = __webpack_public_path__ + "img/humedad_blue.55f45a59.svg";